import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  [DeliveryProvider.UberDrive]: 'Uber',
  [DeliveryProvider.FirstDelivery]: 'Uber',
  [DeliveryProvider.WoltDrive]: 'Wolt',
};
